import { useBlobUrl } from "./useBlobUrl";

const initials = (name = "") => {
  const t = name.trim().split(/\s+/).filter(Boolean);
  return ((t[0]?.[0] || "") + (t.length > 1 ? t[t.length - 1][0] : "")).toUpperCase();
};

export const Avatar = ({ client, path, name, className = "h-10 w-10 text-sm", testId }) => {
  const { url } = useBlobUrl(client, path, !!path);
  const cls = `flex shrink-0 items-center justify-center overflow-hidden rounded-full ${className}`;
  if (path && url) return <img data-testid={testId} src={url} alt={`Foto de ${name}`} className={`${cls} object-cover`} />;
  return <span data-testid={testId} aria-hidden className={`${cls} bg-[#C9A24A] font-bold text-zap-deep`}>{initials(name)}</span>;
};

export const greeting = () => {
  const h = new Date().getHours();
  return h < 12 ? "Bom dia" : h < 18 ? "Boa tarde" : "Boa noite";
};
